import Address from "components/Parts/Address";

const Parts =  {
	Address : Address,

};

export default Parts;
